import { IForm } from '@/components/types'
export const modalConfig: IForm = {
  formItems: [
    {
      field: 'code',
      type: 'select',
      label: '股票代码',
      placeholder: '填写或搜索股票代码或名称',
      filterable: true,
      options: [],
      rules: { required: true, message: '素材类型是必选的', trigger: 'blur' }
    },
    {
      field: 'belong',
      type: 'select',
      label: '归属模块',
      multiple: true,
      placeholder: '请选择归属模块',
      options: [],
      rules: { required: true, message: '归属模块是必选的', trigger: 'blur' }
    },
    {
      field: 'belongTo',
      type: 'input',
      label: '推荐老师',
      placeholder: '请输入推荐老师'
    },
    {
      field: 'date',
      type: 'datepicker',
      label: '指定日期',
      otherOptions: {
        placeholder: '指定日期',
        type: 'date',
        'value-format': 'YYYY-MM-DD'
      }
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
